import React, { FC, RefObject, useCallback, useMemo } from "react";
import { ScrollView } from "react-native";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { useStaticInfo } from "../../hooks/useStaticInfo";
import { BackToTopSection } from "../../tracking/tracking";
import { useTrackBackToTop } from "../../tracking/useTrackBackToTop";
import { style as backToTopButtonStyle } from "./BackToTopButton.styles";

interface BackToTopButtonProps {
  readonly scrollViewRef: RefObject<ScrollView | null>;
  readonly section: BackToTopSection;
}

const BackToTopButton: FC<BackToTopButtonProps> = ({ scrollViewRef, section }) => {
  const {
    session: { user },
    tradename,
  } = useStaticInfo();

  const style = useMemo(() => backToTopButtonStyle(), []);

  const trackBackToTop = useTrackBackToTop({
    country: user.country,
    segment: user.segment,
    userId: user.id,
    tradename,
  });

  const onPress = useCallback(() => {
    scrollViewRef.current?.scrollTo();
    trackBackToTop({ section });
  }, [scrollViewRef, section, trackBackToTop]);

  return <ButtonIcon name="arrow_up" style={{ button: style.button, icon: style.icon }} onPress={onPress} />;
};

export { BackToTopButton };
